import React, { useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Label from "elements/Label";
import ErrorMessage from "elements/ErrorMessage";
import HelpBtn from "elements/HelpBtn";
import Select from "elements/Select";
import { FormDataContext } from "context/FormDataContext";
import Input from "elements/Input";

function Option({ label, value }) {
  return <option value={value}>{label}</option>;
}

function PurposeSalaryField({
  extendedRequired,
  name,
  label,
  value,
  options,
  step,
}) {
  const {
    updateEmploymentField,
    errors,
    validateField,
    dynamicFieldsList,
    updateDynamicFieldsList,
    jobType,
  } = useContext(FormDataContext);

  const optionsPurpose = options.purpose.map((d, i) => (
    <Option value={d.value} key={i} label={d.label} />
  ));

  let calculatedPercent = 0;

  value.map((e) => {
    if (e[1]) {
      calculatedPercent = calculatedPercent + parseInt(e[1]);
    }
  });

  const handleAddClick = () => {
    updateDynamicFieldsList(name, 1);
  };

  const handleRemoveClick = (i) => {
    value.splice(i, 1);
    validateField(name);
    updateEmploymentField(step, value, name, extendedRequired);
    updateDynamicFieldsList(name, -1);
  };

  const updateField = (e, step, extendedRequired, i, j) => {
    const newValue = e.target.value;
    if (i < value.length) {
      value[i][j] = newValue;
    } else {
      value.push(["", "", ""]);
      value[i][j] = newValue;
    }
    validateField(name);
    updateEmploymentField(step, value, name, extendedRequired);
  };

  const getValue = (i, j) => {
    return value[i] !== undefined ? value[i][j] : "";
  };

  const fields = [];

  for (let i = 0; i < dynamicFieldsList[jobType]?.purpose_salary; i++) {
    fields.push(
      <div key={i}>
        <Flex>
          <Field>
            <Label>Formål</Label>
            <Select
              id={`${name}_fieldOne_${i}`}
              name={`${name}_fieldOne_${i}`}
              onChange={(e) => updateField(e, step, extendedRequired, i, 0)}
              onBlur={(name) => validateField(name)}
              value={getValue(i, 0)}
            >
              {optionsPurpose}
            </Select>
          </Field>
          <Field>
            <Label>Procent</Label>
            <Input
              id={`${name}_fieldTwo_${i}`}
              name="purpose_salary_percent"
              onChange={(e) => updateField(e, step, extendedRequired, i, 1)}
              onBlur={(name) => validateField(name)}
              value={parseInt(getValue(i, 1)) ? parseInt(getValue(i, 1)) : 0}
            />
          </Field>
          <Field>
            <Label>Bemærkninger</Label>
            <Input
              id={name[i]}
              onChange={(e) => updateField(e, step, extendedRequired, i, 2)}
              onBlur={(name) => validateField(name)}
              value={getValue(i, 2)}
            />
          </Field>
          {dynamicFieldsList[jobType].purpose_salary !== 1 && i !== 0 && (
            <HelpBtnAlt type="button" onClick={() => handleRemoveClick(i)}>
              -
            </HelpBtnAlt>
          )}
          {dynamicFieldsList[jobType].purpose_salary - 1 === i && (
            <HelpBtnAlt type="button" onClick={handleAddClick}>
              +
            </HelpBtnAlt>
          )}
        </Flex>
      </div>
    );
  }

  const error = errors.filter((err) => err.name === name);

  return (
    <PurposeSalaryFieldWrapper>
      <Label marginbottom legend>
        {label}
      </Label>
      {fields}
      {error.length > 0 && <ErrorMessage>{error[0].msg}</ErrorMessage>}
    </PurposeSalaryFieldWrapper>
  );
}

const Field = styled.div`
  margin: 0 1em 0.5em 0;
`;

const HelpBtnAlt = styled(HelpBtn)`
  transform: translateY(0.75em);
`;

const PurposeSalaryFieldWrapper = styled.div`
  padding: 0.46875em 0;
`;

const Flex = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

Option.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
};

PurposeSalaryField.defaultProps = {
  extendedRequired: false,
};

PurposeSalaryField.propTypes = {
  step: PropTypes.number,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.array,
  options: PropTypes.object,
  extendedRequired: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      requiredField: PropTypes.string,
      requiredValue: PropTypes.string,
    }),
  ]),
};

export default PurposeSalaryField;
